export const en = {
    translation: {
        errorCodes: {
            PARSE_ERROR: 'Failed to parse',
            BAD_REQUEST: 'Invalid request',
            INTERNAL_SERVER_ERROR: 'Unexpected server error',
            NOT_IMPLEMENTED: 'Not implemented',
            UNAUTHORIZED: 'No valid user',
            FORBIDDEN: 'Access forbidden',
            NOT_FOUND: 'Not found',
            METHOD_NOT_SUPPORTED: 'Method is not supported',
            TIMEOUT: 'A timeout has occurred',
            CONFLICT: 'A conflict has occurred',
            PRECONDITION_FAILED: 'A pre-condition has failed',
            PAYLOAD_TOO_LARGE: 'The payload is too big',
            UNPROCESSABLE_CONTENT: 'Unable to process the data',
            TOO_MANY_REQUESTS: 'Too many requests',
            CLIENT_CLOSED_REQUEST: 'Client has closed the request',
        },
        actions: {
            ok: 'Ok',
            yes: 'Yes',
            no: 'No',
            help: 'Help',
            back: 'Back',
            next: 'Next',
            create: 'Create',
            createAndSend: 'Create and send',
            createNamed: 'Create {{name}}',
            save: 'Save',
            saveDraft: 'Save draft',
            saveDrafts: 'Save drafts',
            accept: 'Accept',
            cancel: 'Cancel',
            close: 'Close',
            confirm: 'Confirm',
            edit: 'Edit',
            editDetails: 'Edit details',
            editSettings: 'Edit settings',
            add: 'Add',
            delete: 'Delete',
            remove: 'Remove',
            replace: 'Replace',
            assign: 'Assign',
            print: 'Print',
            download: 'Download',
            share: 'Share',
            send: 'Send',
            import: 'Import',
            export: 'Export',
            archive: 'Archive',
            unarchive: 'Unarchive',
            preview: 'Preview',
            view: 'View',
            viewDetails: 'View details',
            clear: 'Clear',
            complete: 'Complete',
            apply: 'Apply',
            applyChanges: 'Apply changes',
            submit: 'Submit',
            copyToClipboard: 'Copy to clipboard',
            useUserTimezone: 'Use my timezone',
            applyFilter: 'Apply filter',
            clearFilter: 'Clear filter',
            loadMore: 'Load more',
            more: 'More',
            upload: 'Upload',
            moveUp: 'Move up',
            moveDown: 'Move down',
            moveLeft: 'Move left',
            moveRight: 'Move right',
            duplicate: 'Duplicate',
            openInNewTab: 'Open in new tab',
            info: 'Info',
            actions: 'Actions',
            reject: 'Reject',
            read: 'Read',
            unread: 'Unread',
            email: 'Email',
            applicant: 'Applicant',
            name: 'Name',
            services: 'Services',
            team: 'Team',
            seat: 'Seat',
            move: 'Move',
            collect: 'Collect',
            request: 'Request',
            bookable: 'Bookable',
            invoice: 'Invoice',
            message: 'Message',
        },
        misc: {
            sortedBy: 'sorted by',
            sortAscending: 'Sort ascending',
            sortDescending: 'Sort descending',
            today: 'Today',
            calendarWeek: 'CW',
            copiedToClipboard: 'Copied to clipboard',
            tagsEdit: 'Type to add tags',
            tagsReadOnly: 'No tags available',
            required: 'Required',
            notAvailable: 'Not available',
            optional: 'Optional',
            all: 'All',
            none: 'None',
            of: 'of',
            selected: 'selected',
            allSelected: 'All selected',
        },
        components: {
            markdown: {
                showMoreCode: 'Show more',
            },
            label: {
                showHint: 'Show hint',
            },
            sidebar: {
                title: 'Sidebar',
                description: 'Displays the mobile sidebar.',
                toggle: 'Toggle sidebar',
            },
            commandDialog: {
                title: 'Command palette',
                description: 'Search for a command to run',
            },
            noMandate: {
                title: 'Select a mandate',
                message: 'Choose a mandate to continue.',
            },
            imageGallery: {
                open: 'Open image gallery',
            },
            table: {
                showAllValues: 'Show all values',
                showDetails: 'Show details',
                hideDetails: 'Hide details',
                selectRow: 'Select row',
                selectAll: 'Select all',
                clearSelection: 'Clear selection',
                sort: 'Sort',
                sortBy: 'Sort: {{column}}',
                sortAscending: 'Sort ascending',
                sortDescending: 'Sort descending',
            },
            addressForm: {
                addressComplete: {
                    defaultPlaceholder: 'Start typing your address',
                    noResults: 'No addresses found. Try a different search or enter an address manually.',
                    searchError: 'Could not search for addresses. Try again or enter an address manually.',
                    enterManually: 'Enter an address manually',
                },
                addressFields: {
                    country: 'Country',
                    zip: 'Zip',
                    city: 'City',
                    state: 'State',
                    detailsRecipient1: 'Further receiver detail (ie company or c/o)',
                    detailsRecipient2: 'Further receiver detail (ie floor level)',
                    detailsPlace1: 'Further place details (ie apartment)',
                    detailsPlace2: 'Further place details (ie floor level)',
                    addDetails: 'Add additional lines',
                    removeDetails: 'Remove additional lines',
                    addressLine: 'Street with number',
                },
            },
            simpleFormView: {
                addItemCaption: 'Add an item',
                addItemCaptionMore: 'Add another item',
                itemCaption: 'Item',
                selectMinMaxChoices: 'Select minimum {{min}} and maximum {{max}}',
                selectMinChoices: 'Select minimum {{min}}',
                selectMaxChoices: 'Select maximum {{max}}',
                acceptTermsStart: 'I accept the',
                acceptTermsLink: 'terms and conditions',
                acceptTermsEnd: '',
                acceptPrivacyStart: 'I consent to the',
                acceptPrivacyLink: 'data privacy agreement',
                acceptPrivacyEnd: '',
                acceptAgreement: 'Agreement',
                noTermsOrPrivacy: 'No terms or privacy agreement has been provided',
                noSelectableItems: 'No {{groupName}} available',
                noPaymentMethods: 'No payment methods are available',
                file: { addFile: 'Add file' },
                signature: {
                    loading: 'Loading signature field...',
                    draw: 'Draw',
                    upload: 'Upload',
                    uploadedPreview: 'Uploaded signature preview',
                    undo: 'Undo',
                    clear: 'Clear',
                },
                paymentMethod: {
                    payVia: 'Pay via {{paymentMethodType}}',
                    paymentMode: {
                        oneTime: 'One-time payment',
                        recurring: 'Recurring payment',
                    },
                    paymentMethodType: {
                        sepaDirectDebit: 'SEPA direct debit',
                        sepaCreditTransfer: 'SEPA credit transfer',
                        cash: 'Cash',
                        online: 'Online',
                        paypal: 'PayPal',
                    },
                    sepaDirectDebit: {
                        iban: 'IBAN',
                        bic: 'BIC',
                        creditor: 'Creditor',
                        creditorIdentifier: 'Creditor ID',
                        terms: {
                            oneTime:
                                'I authorise "{{organizationName}}" to collect the due amount once from my account by SEPA Core Direct Debit. I also instruct my bank to honour the direct debit drawn by "{{organizationName}}" from my account. I may request a refund of the debited amount within eight weeks from the debit date, under the conditions agreed with my bank.',
                            recurring:
                                'I authorise "{{organizationName}}" to collect due recurring payments from my account by SEPA Core Direct Debit. I also instruct my bank to honour the direct debits drawn by "{{organizationName}}" from my account. I may request a refund of each debited amount within eight weeks from the relevant debit date, under the conditions agreed with my bank.',
                        },
                        mandateAcceptance: {
                            oneTime:
                                'I authorise "{{organizationName}}" to use the SEPA Direct Debit Mandate above for this one-off payment.',
                            recurring:
                                'I authorise "{{organizationName}}" to use the SEPA Direct Debit Mandate above for recurring payments.',
                        },
                    },
                },
            },
            control: {
                phoneInput: {
                    invalidPhoneNumber: 'Invalid phone number for the given country',
                    noMatchingCountry: 'No matching country',
                },
                passwordInput: {
                    show: 'Show password',
                    hide: 'Hide password',
                },
                searchInput: { placeholder: 'Search' },
                combobox: {
                    createOption: 'Add {{query}}',
                    noOptions: 'No options found',
                    loading: 'Loading ...',
                    loadingMore: 'Loading more ...',
                    placeholder: 'Select an option',
                },
            },
            misc: {
                propertyFilterEditor: {
                    favorites: 'Favorites',
                    groupActions: 'Group actions',
                    addProperty: 'Add property to group',
                    duplicateGroup: 'Duplicate group',
                    deleteGroup: 'Delete group',
                    configureProperty: 'Configure property',
                    selectValue: 'Select value',
                    selectOperator: 'Select operator',
                    addFilter: 'Add filter',
                    dynamicProperty: 'Dynamic property',
                    missingProperty: 'Invalid property',
                    missingSourceProperty: 'Invalid source property',
                    removeProperty: 'Clear property',
                    selectProperty: 'Select a property',
                },
                dateSelector: {
                    rangePreset: {
                        action: 'Quick ranges',
                        currentMonth: 'Current month',
                        currentMonthCompact: 'Month',
                        currentQuarter: 'Current quarter',
                        currentQuarterCompact: 'Quarter',
                        currentYear: 'Current year',
                        currentYearCompact: 'Year',
                        previousYear: 'Previous year',
                        previousYearCompact: 'Prev year',
                    },
                },
            },
            dialog: { confirm: { prefix: 'Please confirm by typing the following text bellow:' } },
            form: {
                submitError: 'Something went wrong during submitting please try again',
                submitSuccess: 'Changes successfully saved',
                deleteError: 'Something went wrong during deletion please try again',
                deleteSuccess: 'Successfully deleted',
            },
            ui: {
                dateInput: {
                    invalidDateFormat: 'Invalid date format',
                    dateBeforeMinDate: 'Date is before the allowed minimum date',
                    dateAfterMaxDate: 'Date is after the allowed maximum date',
                },
                datePicker: { selectDate: 'Select date' },
                numberInput: { decrease: 'Decrease', increase: 'Increase' },
                richTextEditor: {
                    editorPlaceholder: 'Type "/" for more actions or enter text',
                    toolbar: {
                        insertTag: 'Placeholder',
                        moreActions: 'More actions',
                        bold: 'Bold',
                        italic: 'Italic',
                        strikethrough: 'Strikethrough',
                        highlight: 'Highlight',
                        link: 'Insert link',
                    },
                    tags: { search: 'Search tags', empty: 'No tags found', sample: 'Sample', ungrouped: 'General' },
                    groups: { inline: 'Formatting', text: 'Text', lists: 'Lists', other: 'Other' },
                    blocks: {
                        h1: 'Heading 1',
                        h2: 'Heading 2',
                        h3: 'Heading 3',
                        quote: 'Quote',
                        divider: 'Divider',
                        bulletList: 'Bullet list',
                        orderedList: 'Ordered list',
                        taskList: 'Task list',
                        codeBlock: 'Code block',
                        table: 'Table',
                        image: 'Image',
                    },
                    errors: {
                        tagsNotAllowed: 'The following tags are not allowed: {{tags}}',
                        minLength: 'Please enter at least {{length}} characters',
                        maxLength: 'Please enter at most {{length}} characters',
                    },
                },
                timePicker: { selectTime: 'Select time' },
            },
            fileStorageResourceSelect: {
                select: 'Select file',
                change: 'Change file',
                clear: 'Clear',
                download: 'Download',
                info: { maxFileSizeLabel: 'Max file size', allowedTypesLabel: 'Allowed file types' },
                dropzone: {
                    emptyTitle: 'Drag and drop a file here',
                    emptyInfo: 'Or click to select a file',
                    replaceTitle: 'Drag and drop a file here to replace it',
                    replaceInfo: 'Or click to choose another file',
                },
            },
            imageStorageResourceSelect: { select: 'Select image', change: 'Change image', clear: 'Clear' },
            useUpload: {
                fileTooLarge: { title: 'File too large', message: 'The given file is too large for uploading' },
                uploadError: {
                    title: 'Upload failed',
                    message: 'Some error ocurred during uploading, please try again',
                },
                progress: 'Uploading file ({{progress}}%)...',
            },
            actorName: { currentUser: 'You', deletedUser: 'Deleted user', deletedContact: 'Deleted contact' },
            pageWorkspace: {
                tabs: {
                    label: 'Open pages',
                    scrollLeft: 'Scroll tabs left',
                    scrollRight: 'Scroll tabs right',
                    closeTab: 'Close {{name}}',
                    reorderInstructions: 'Press Alt+Shift+Left or Right to move this tab. Press Delete to close it.',
                    moving: 'Moving {{name}}.',
                    moved: '{{name}} moved to position {{position}}.',
                    moveCancelled: 'Tab move cancelled.',
                },
                openAsPage: 'Open as page',
                discardChanges: 'Discard your unsaved changes?',
                loadError: 'Could not load this page',
                loading: 'Loading page',
                retry: 'Try again',
                retryRefresh: 'Refresh list',
                refreshError:
                    'Your changes were saved, but the list could not be refreshed. Use “Refresh list” to try again.',
            },
            page: {
                toolbar: {
                    filters: 'Filters',
                },
                actions: {
                    toggleAppSidebar: 'App-Seitenleiste umschalten',
                    togglePageSidebar: 'Seiten-Seitenleiste umschalten',
                    copyPageUrl: 'Copy page URL',
                    openInNewWindow: 'Open in new window',
                    copyPageUrlSuccess: 'Page URL copied',
                    pageOptions: 'Page options',
                },
                selection: {
                    clear: 'Clear selection',
                    more: 'More actions',
                },
            },
            amountModifierInput: { plus: 'Plus', minus: 'Minus', set: 'As amount', percentage: 'Percent' },
            emptyState: {
                noAccess: {
                    title: 'No access',
                    subtitle: 'You have no access to this action',
                    requiredPermissions: 'Required permissions',
                },
            },
            fileUpload: {
                tooBig: {
                    title: 'Some file(s) are too big',
                    message: 'One or more files are are exceeding the allowed maximum file sizeof {{maxSize}}',
                },
                uploadTitle: 'Uploading',
                dropFilesTitle: 'Dropt the file(s) now',
                dropHereTitle: 'Drop your file or',
                dropHereMultipleTitle: 'Drop your files or',
                selectFiles: 'click here to choose',
                format: 'Format',
                size: 'Size',
            },
            pagination: {
                label: 'Pagination',
                previousPage: 'Previous page',
                nextPage: 'Next page',
                show: 'Showing {{fromCount, int}} to {{toCount, int}}',
                total: 'of {{count, int}} total',
            },
            paymentMethod: {
                payVia: 'Pay via {{paymentMethod}}',
                label: 'Payment method',
                online: {
                    terms: 'You will receive a link with payment instructions after your booking. We kindly ask that the payment be completed by {{dueDate}}.',
                    cardBrandNotSupported:
                        'This card type isn’t supported. Please try an alternative card brand. Thank you for your understanding',
                    paypal: { name: 'Pay via PayPal', methodName: 'PayPal' },
                    stripe: {
                        name: 'Pay online',
                        methodName: 'online',
                        status: {
                            notAvailable: 'Online payment is not enabled',
                            error: 'An error ocurred initializing online payment',
                        },
                    },
                    amountTooLow:
                        'The amount is too low to be processed. The minimum amount supported for this payment method is {{amount}}.',
                },
                sepaDirectDebit: {
                    name: 'Pay via sepa direct debit',
                    methodName: 'SEPA direct debit',
                    terms: 'By providing the payment information and confirming the booking, you authorize (A) {{organizationName}} to collect this payment from your account by direct debit. At the same time (B) you instruct your bank to debit your account in accordance with these instructions. You are entitled to a refund from your bank in accordance with the terms and conditions agreed with your bank. You may request reimbursement of the debited amount within eight weeks of the debit date. The conditions agreed with your bank apply.',
                },
                sepaCreditTransfer: {
                    name: 'Pay via credit transfer',
                    methodName: 'credit transfer',
                    terms: 'You will receive a receipt with payment information to transfer the money to after your booking.',
                },
                cash: { name: 'Pay via cash', methodName: 'cash' },
            },
            useSelectFile: {
                tooBig: {
                    title: 'Some file(s) are too big',
                    message: 'One or more files are are exceeding the allowed maximum file sizeof {{maxSize}}',
                },
            },
        },
        app: {
            error: {
                title: "Oops! Something's wrong here...",
                event: 'Event: {{event}}',
                goBack: 'Go Back',
                or: 'or',
                support: 'Contact our support team',
            },
        },
        donation: {
            form: {
                amountField: {
                    customAmount: 'Other amount',
                },
                paymentMethodField: {
                    noPaymentMethodAvailable: 'No payment method is available for this form.',
                    sepaCreditTransferTerms: 'You will get the account details for your transfer after sending the form.',
                },
                summaryField: {
                    coverFees: 'I add {{amount}} to cover the costs of the payment',
                    total: 'Your donation',
                },
            },
        },
        booking: {
            cancelRefund: {
                and: 'and',
                buyer: {
                    priceLead: 'You will receive',
                    pricePointsTail: 'points.',
                    pointsTail: 'points.',
                    none: 'You will not receive a refund.',
                },
                issuer: {
                    pricePrefix: '',
                    priceTail: 'will be refunded.',
                    pricePointsTail: 'points will be refunded.',
                    pointsTail: 'points will be refunded.',
                    none: 'No refund will be issued.',
                },
            },
            editor: {
                buyerEditor: {
                    title: {
                        withBookingNumber: 'Edit buyer/applicant of booking "{{bookingNumber}}"',
                        withoutBookingNumber: 'Edit buyer/applicant',
                    },
                    description:
                        'Any receipts linked to this booking will be updated automatically. The updated receipts will not be sent automatically, but you can send them manually later if needed.',
                    name: 'Name',
                    phone: 'Phone',
                    email: 'Email',
                    emailInfo: 'In case the email is changed, all failed emails will be resent.',
                    personName: 'Person name',
                    address: 'Address',
                },
                servicesEditor: {
                    title: 'Edit services',
                    description: 'You can adjust the services for this booking',
                    removedServices: {
                        title: 'Services removed',
                        refundInfo:
                            'The following services will be refunded. You can adjust the refund amount for each service, or choose not to issue a refund.',
                        refund: 'Refund',
                        total: 'Total to refund',
                        reset: 'Reset to original amount',
                    },
                    addedServices: {
                        title: 'Added services',
                        chargeInfo:
                            'The following services will be charged in a new receipt. You can also choose not to charge for any of the services.',
                        charge: 'Charge',
                        total: 'Total to charge',
                    },
                    confirm: {
                        title: 'Confirm the changes',
                        message:
                            'Are you sure you want to proceed with the changes? This can not be made undo.\n' +
                            '\n' +
                            'Total to refund: {{amountToRefund}}\n' +
                            'Total to charge: {{amountToCharge}}',
                        confirm: 'Confirm',
                        cancel: 'Cancel',
                    },
                },
            },
            event: { attendeeEditor: { title: 'Edit attendee' } },
            resource: {
                form: {
                    addSlot: 'Add slot',
                    removeSlot: 'Remove slot',
                    addQuantity: 'Add quantity',
                    removeQuantity: 'Remove quantity',
                },
            },
        },
        developer: {
            app: {
                host: {
                    form: { submitError: 'Unable to submit the form.' },
                    widget: { loadError: 'Unable to load widget.' },
                },
            },
        },
        routes: { errorPage: { goBack: 'Go back' } },
        utils: {
            booking: {
                event: {
                    recurringSeriesFutureDatesInfo: {
                        label: 'Future dates are still not defined.',
                        description:
                            'This series continues beyond the dates currently shown. Future dates will be added automatically as the series progresses.',
                    },
                    eventBadges: {
                        ended: 'Ended',
                        canceled: 'Canceled',
                        blockedResource: 'Blocked',
                        blockedCalendar: 'Blocked',
                        available: 'Available',
                        waitlist: 'Waitlist',
                        seatsAvailable_zero: 'Full',
                        seatsAvailable_one: 'One seat left',
                        seatsAvailable_other: '{{count, number}} seats left',
                        seatsAvailableMany: 'Available',
                        availableFrom: 'Soon',
                        bookableFrom: 'Bookable from {{date}}',
                        availableTo: 'Closed',
                        notAvailable: 'Closed',
                    },
                    simpleForm: {
                        ticketsField: {
                            membership: 'Membership information',
                            attendeeName: 'Attendee name',
                            attendeePlaceholder: 'John Doe',
                            services: 'Additional services',
                            ticket: 'Ticket',
                        },
                        summaryField: {
                            eventSeries: '({{count, number}} of {{total, number}} events)',
                            anonymous: 'Anonymous',
                            tickets_one: '{{rateName}} ({{attendeeName}}) - {{count, number}} ticket',
                            tickets_other: '{{rateName}} ({{attendeeName}}) - {{count, number}} tickets',
                            waitlisted: 'On waitlist',
                            confirmationRequired: 'The booking must be confirmed manually by our team',
                        },
                        selectableRateField: {
                            contactMemberTicket:
                                'For each rate, the selected contact supplies the membership for one ticket requiring individual membership.',
                            noRate: 'Rate was not found',
                            removeQuantity: 'Remove quantity',
                            addQuantity: 'Add quantity',
                            quantity: 'Define how many tickets will be booked for this rate',
                            tickets: 'tickets',
                            price_one: 'ticket ({{price}})',
                            price_other: 'tickets ({{price}})',
                            points_one: 'tickets ({{points}} pts)',
                            points_other: 'tickets ({{points}} pts)',
                        },
                    },
                },
                simpleForm: {
                    rateField: {
                        selectRate: 'Select a rate',
                        selectRateRequired: 'Please select a rate',
                        membersOnly: 'For members only',
                        selectRateVariant: 'Select a variant for this rate',
                        punchCardPurchsable: 'Punchcard can be purchased',
                        punchCard: 'Punchcard',
                        quantity: 'Minimum {{quantity}} tickets',
                        attendee: 'Attendee {{index}}',
                        attendeeName: 'Full name',
                        attendeeNamePlaceholder: 'John Doe',
                        availableStatus: {
                            soldOut: 'Sold out',
                            notYetAvailable: 'Available soon',
                            noLongerAvailable: 'Expired',
                            waitlist: 'On waitlist',
                        },
                        punchCardSelector: {
                            info: 'Provide an existing {{name}} punch card or buy a new one which gets immediately charged then',
                            existingCard: 'Use existing card',
                            buyNewCard: 'Buy a new card for {{price}}',
                            useNewlyBoughtCard: 'Use card being bought',
                        },
                    },
                    servicesField: {
                        noService: 'No optional service',
                        selectionLabel: 'Select an optional service',
                        selectServices: 'Select additional services',
                        requiredServices: 'Required services',
                        selectMinMaxOptions: 'Select minimum {{min}} and maximum {{max}}',
                        selectMinOptions: 'Select minimum {{min}}',
                        selectMaxOptions: 'Select maximum {{max}}',
                        availableStatus: { soldOut: 'Sold out' },
                        serviceChargedOnce: 'Charged once',
                        serviceChargedTitle: 'Charged once for all tickets. Note: This service is non-refundable.',
                    },
                    summaryField: {
                        priceSubTotal: 'Subtotal',
                        discountCode: 'Discount code',
                        price: 'Total amount',
                        points: 'Total points',
                        priceToPay: 'To pay now',
                        pointsToUse: 'Points used now',
                        paymentDueBy: 'Payment due by',
                    },
                    discountField: { inputPlaceholder: 'Enter discount code', applyCode: 'Apply code' },
                    refundPoliciesField: {
                        title: 'Cancelation and refund policy',
                        refundLabel: 'When canceled {{time}} before {{refunds}}',
                        refundsBoth: '{{priceRefund}} or {{pointRefund}}',
                        priceRefund: {
                            none: 'the price will not be refunded',
                            amount: '{{amount}} will be charged as cancelation fees',
                            '%': '{{percentage}}% of the paid price will be refunded',
                        },
                        pointRefund: {
                            none: 'the used points will not be refunded',
                            amount: '{{amount}} points will be charged as cancelation fees',
                            '%': '{{percentage}}% of the used points will be refunded',
                        },
                        noRefund: 'No refunds',
                    },
                    paymentMethodField: {
                        noPaymentMethodAailable: 'No payment methods have yet been setup for this event',
                    },
                    memberInfo: {
                        birthdatePart: { day: 'Day', month: 'Month', year: 'Year' },
                        info: 'Please provide more details to identify as a member for the rate',
                        perTicketInfo: 'Please provide more details to identify as a member for the ticket',
                        birthdate: 'Birthdate',
                        membershipNumber: 'Membership number',
                        birthdateInfo:
                            'If you are booking on behalf of an organisation member simply leave the birthdate empty',
                        loadingMemberDetails: 'Loading member details',
                        validatingMembershipNumber: 'Validating membership number',
                        membershipNumberValid: 'Valid membership number',
                    },
                },
            },
            reports: { noData: 'No data to be exported' },
            webPush: {
                granted: {
                    title: 'Browser push notifications are allowed',
                },
                default: {
                    title: 'Browser push notifications are not enabled',
                },
                denied: {
                    title: 'Browser push notifications are blocked',
                },
                unsupported: {
                    title: 'Browser push notifications are not supported',
                },
                permissionPrompt: {
                    dialogTitle: 'Enable browser push notifications?',
                    dialogDescription:
                        'Campai can send notifications through this browser. If you choose yes, your browser will ask for permission. If the browser prompt does not appear, check your browser settings.',
                    confirm: 'Yes, enable',
                    cancel: 'Not now',
                },
                permissionDenied: {
                    dialogTitle: 'Browser push notifications are blocked',
                    dialogDescription:
                        'You denied push notifications for this browser. Enable notifications for this site in your browser settings if you want to receive them here.',
                },
                permissionUnsupported: {
                    dialogTitle: 'Browser push notifications are not supported',
                    dialogDescription:
                        'This browser does not support push notifications for this site. Use a supported browser if you want to receive them here.',
                },
            },
        },
    },
}
